<template>
  <div class="Field-Hdr">
    <div class="Field-Hdr__group">
      <span class="Field-Hdr__label" v-if="props.label">{{ props.label }}</span>
      <span class="Field-Hdr__option" v-if="props.option">{{ props.option }}</span>
    </div>
    <span class="Field-Hdr__counter" v-if="props.maxItems">
      {{ props.counter }}/{{ props.maxItems }}
    </span>
  </div>
</template>

<script setup>
  import { Props } from "./scripts/props";
  //---------------------------------
  const props = defineProps(Props());
</script>

<style lang="scss">
  @import "styles/styles";
</style>
